import styled from 'styled-components';

const Icon = styled.span`
  svg {
    height: 20px;
    width: 20px;
    fill: ${(p) => p.theme.color.gray};
  }
  height: 20px;
  width: 20px;
  &:hover  {
    cursor: pointer;
  }
`;

export const Styled = {
  Icon,
};
